import { ViewEncapsulation } from '@angular/core';
import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

declare let $:any;
@Component({
  selector: 'app-tracenow-mobile-app',
  templateUrl: './tracenow-mobile-app.component.html',
  styleUrls: ['./tracenow-mobile-app.component.css'],
  
})
export class TracenowMobileAppComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
    
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/tracenow-mobile-app/tracenow-mobile-app.component.ts